import { register, findAll, find } from '../../../../Javascript/Sysmex/Utils'

const GalleryList = el => {
  const componentPrefix = el.dataset.componentprefix
  const componentCardsPrefix = 'sysmexeuropeOrganismGalleryList_'
  const radioGroupCardLayoutSwitch = find(`.${componentPrefix}cardLayoutSwitch`, el)
  const triggers = findAll('input[type="radio"]', radioGroupCardLayoutSwitch)
  const galleryLayouts = findAll('.gallery-layout')
  const galleryCards = findAll(`.${componentCardsPrefix}galleryCard`, el)

  triggers.forEach(trigger => {
    trigger.addEventListener('click', function () {
      const cardLayout = trigger.value
      galleryCards.forEach(galleryCard => {
        galleryCard.dataset.cardlayout = cardLayout
      })

      galleryLayouts.forEach(galleryLayout => {
        if (cardLayout !== 'list') {
          galleryLayout.classList.add('col-large-4')
        } else {
          galleryLayout.classList.remove('col-large-4')
        }
      })
    })
  })
}

register('GalleryList', GalleryList)
